<legal-entity-form [legalEntity]="legalEntity"></legal-entity-form>
